var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServerless(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "51px",
    viewBox: "0 0 73 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    fill: "#C7C7C7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 73,
    height: 51
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C94E2A",
    x: 29.2817955,
    y: 10,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(35.254017, 11.422680) rotate(22.000000) translate(-35.254017, -11.422680) ",
    x: 33.4585054,
    y: 10.5318118,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69FFB6",
    transform: "translate(38.832723, 13.380066) rotate(43.000000) translate(-38.832723, -13.380066) ",
    x: 37.0372115,
    y: 12.4891974,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(40.714987, 16.457750) rotate(85.000000) translate(-40.714987, -16.457750) ",
    x: 38.9194761,
    y: 15.5668813,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(47.689547, 15.628817) rotate(16.000000) translate(-47.689547, -15.628817) ",
    x: 45.8940357,
    y: 14.7379481,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(50.689547, 21.628817) rotate(104.000000) translate(-50.689547, -21.628817) ",
    x: 48.8940357,
    y: 20.7379481,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEE65F",
    transform: "translate(43.899368, 15.727830) rotate(-13.000000) translate(-43.899368, -15.727830) ",
    x: 42.103857,
    y: 14.836961,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E152C5",
    transform: "translate(52.077307, 24.890869) rotate(10.000000) translate(-52.077307, -24.890869) ",
    x: 50.2817955,
    y: 24,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEE65F",
    transform: "translate(55.950857, 27.823086) rotate(55.000000) translate(-55.950857, -27.823086) ",
    x: 54.1553457,
    y: 26.9322172,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D40127",
    transform: "translate(50.077307, 17.890869) rotate(56.000000) translate(-50.077307, -17.890869) ",
    x: 48.2817955,
    y: 17,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C94E2A",
    transform: "translate(57.077307, 31.890869) rotate(85.000000) translate(-57.077307, -31.890869) ",
    x: 55.2817955,
    y: 31,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69FFB6",
    transform: "translate(56.077307, 35.890869) rotate(135.000000) translate(-56.077307, -35.890869) ",
    x: 54.2817955,
    y: 35,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#78A045",
    transform: "translate(53.077307, 38.890869) rotate(160.000000) translate(-53.077307, -38.890869) ",
    x: 51.2817955,
    y: 38,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#78A045",
    transform: "translate(19.077307, 23.890869) rotate(135.000000) translate(-19.077307, -23.890869) ",
    x: 17.2817955,
    y: 23,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E152C5",
    transform: "translate(23.077307, 21.890869) rotate(181.000000) translate(-23.077307, -21.890869) ",
    x: 21.2817955,
    y: 21,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(16.077307, 27.890869) rotate(109.000000) translate(-16.077307, -27.890869) ",
    x: 14.2817955,
    y: 27,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69FFB6",
    transform: "translate(21.077307, 38.890869) rotate(209.000000) translate(-21.077307, -38.890869) ",
    x: 19.2817955,
    y: 38,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E152C5",
    transform: "translate(17.717440, 35.905641) rotate(241.000000) translate(-17.717440, -35.905641) ",
    x: 15.9219287,
    y: 35.0147729,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEE65F",
    transform: "translate(15.717440, 31.905641) rotate(265.000000) translate(-15.717440, -31.905641) ",
    x: 13.9219287,
    y: 31.0147729,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.585
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69FFB6",
    transform: "translate(24.077307, 14.890869) rotate(135.000000) translate(-24.077307, -14.890869) ",
    x: 22.2817955,
    y: 14,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.584999979
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(27.247845, 12.106649) rotate(151.000000) translate(-27.247845, -12.106649) ",
    x: 25.4523335,
    y: 11.2157804,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.584999979
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(22.077307, 18.890869) rotate(94.000000) translate(-22.077307, -18.890869) ",
    x: 20.2817955,
    y: 18,
    width: 3.59102244,
    height: 1.78173719,
    rx: 0.584999979
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#69A4FF",
    transform: "translate(36.781796, 40.000000) rotate(180.000000) translate(-36.781796, -40.000000) ",
    x: 23.2817955,
    y: 39,
    width: 27,
    height: 2,
    rx: 0.584999979
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerless);
export default __webpack_public_path__ + "static/media/serverless.5aee6ecb23714f52eba0714279e42d5b.svg";
export { ForwardRef as ReactComponent };